import type { TileImage, Variation } from '@shared/types/types.ts';
import type { ProductLink } from '@tile/components/product-link/ProductLink';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';
import { getStatusQuoImages } from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapFashionTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';
import { mapLink } from '../mapping/ProductLink';

export type FashionLayout = {
    /**
 *
 */
    readonly variation: Variation;

    /**
 *
 */
    readonly title: ProductTitle;

    readonly link: ProductLink;

    readonly images: TileImage[];

    readonly primaryImage: TileImage;
};

/**
 *
 *
 */
export function createFashionLayout(variation: Variation): FashionLayout {
    const { images, primaryImage } = getStatusQuoImages(variation.images);
    return {
        variation,
        title: mapFashionTitle(variation),
        link: mapLink(variation),
        images,
        primaryImage,
    };
}
